import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatLegacyDialogRef } from '@angular/material/legacy-dialog';
import { CtFileUploaderConfiguration } from '@ctsolution/ct-framework';

@Component({
  selector: 'app-to-sign-upload',
  templateUrl: './to-sign-upload.component.html',
  styleUrls: ['./to-sign-upload.component.scss']
})
export class ToSignUploadComponent {
  
  form: FormGroup;
  FILE_UPLOADER_ARCHIVE_FORMATS: string[] = ["zip", "application/octet-stream", "application/zip", "application/x-zip", "application/x-zip-compressed"];

  CTFileUploaderConfiguration: CtFileUploaderConfiguration = CtFileUploaderConfiguration
  .create()
  .setTitle('Carica qua il tuo file ZIP.')
  .setLimit(1)
  .setAcceptedFormats(this.FILE_UPLOADER_ARCHIVE_FORMATS)
  .setControlValidators([Validators.required])
  .setSize(100000000)

  constructor(private formBuilder: FormBuilder,private dialogRef: MatLegacyDialogRef<ToSignUploadComponent>) {

    this.form = this.formBuilder.group({});

  }


  ngAfterViewInit(): void {

    this.form
    .addControl('File', this.CTFileUploaderConfiguration.control)
    
  }

  submit() {

    if(this.form.valid){

      const value = this.form.value;

      const param = value.File

      this.dialogRef.close(param);  

    }


}

  close(){

    this.dialogRef.close(null);

  }

}
